import * as React from "react";
import { Link } from "react-router-dom";

// The footer's links in two short columns, so a new one is a row rather
// than another turn of a wrapping line.
const Footer: React.FC = () => (
  <footer className="footer">
    <p className="footer-tag">
      <span className="footer-brand">Khipur</span> — one shelf for every kind of
      media.
    </p>
    <nav className="footer-links" aria-label="Footer">
      <div className="footer-col">
        <p className="eyebrow footer-head">Explore</p>
        <Link to="/guides">Switch to Khipur</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/changelog">Changelog</Link>
      </div>
      <div className="footer-col">
        <p className="eyebrow footer-head">Help</p>
        <a href="mailto:support@khipur.com">Support</a>
        <Link to="/sources">Data sources</Link>
        <Link to="/privacy">Privacy</Link>
        <a
          href="https://buymeacoffee.com/khipur"
          target="_blank"
          rel="noopener noreferrer"
        >
          Buy me a coffee
        </a>
      </div>
    </nav>
    <p className="footer-copy">© {new Date().getFullYear()} Khipur</p>
  </footer>
);

export default Footer;
